const addDotAtTheEndOfString = (value)=>{
    if (!value) return value;
    if ('.' === value.charAt(value.length - 1)) return value;
    return `${value}.`;
};
export { addDotAtTheEndOfString };
